export const colorMoods = [
  { label: "Auto", value: "auto" },
  { label: "Calm", value: "calm" },
  { label: "Energized", value: "energetic" },
  { label: "Warm", value: "warm" },
  { label: "Playful", value: "playful" },
  { label: "Dramatic", value: "dramatic" },
  { label: "Sophisticated", value: "sophisticated" },
];
export const colorSchemes = [
  { label: "Auto", value: "auto" },
  { label: "Monochrome", value: "monochrome" },
  // { label: "Monochrome Light", value: "monochrome-light" },
  // { label: "Monochrome Dark", value: "monochrome-dark" },
  // { label: "Triadic", value: "triad" },
  // { label: "Quadratic", value: "quad" },
  { label: "Analogous", value: "analogic" },
  { label: "Complementary", value: "complement" },
  // { label: "Analogous Complementary", value: "analogic-complement" },
];

export const PALETTE_TYPES = {
  WHEEL: "wheel",
  SEGMENT: "segment",
};
